import React, { useState } from "react";
import moment from "moment";
import DeliveryCalendar from "../../Catalogue/DeliveryDetails/DeliveryCalendar/DeliveryCalendar";

import { useDeliveryForm } from "./hooks/useDeliveryForm";
import { useOrdersData } from "./hooks/useOrdersData";
import { useDeliveryData } from "./hooks/useDeliveryData";

import DeliveryDialogHeader from "./components/DeliveryDialogHeader";
import DeliveryTypeReminder from "./components/DeliveryTypeReminder";
import OrdersSelector from "./components/OrdersSelector";
import DeliveryDialogFooter from "./components/DeliveryDialogFooter";
// import { addWeekdays } from "../../../Utils";
import TransporterSelector from "./components/TransporterSelector";

function DeliveryDialog({
  estimatedDeliveryDate,
  realDeliveryDate,
  orderId,
  orderNumber,
  isEstimatedDate,
  deliveryType,
  entrepot,
}) {
  const [currentTransporter, setCurrentTransporter] = useState();

  const { formData, setFormData, handleChange, handleSubmit, handleCancel } =
    useDeliveryForm({
      estimatedDeliveryDate,
      realDeliveryDate,
      orderId,
      isEstimatedDate,
      currentTransporter,
      entrepot,
    });

  useDeliveryData({
    orderId,
    realDeliveryDate: formData.realDeliveryDate,
    estimatedDeliveryDate: formData.estimatedDeliveryDate,
    isEstimatedDate,
    setFormData,
  });

  const { orders, loading: ordersLoading } = useOrdersData(
    formData.estimatedDeliveryDate,
    formData.realDeliveryDate,
    formData.orders,
    isEstimatedDate,
    orderId,
  );

  const currentDate = isEstimatedDate
    ? formData.estimatedDeliveryDate
    : formData.realDeliveryDate;

  const dateFieldName = isEstimatedDate
    ? "estimatedDeliveryDate"
    : "realDeliveryDate";

  const isSubmitDisabled = currentDate === undefined;

  return (
    <div className="deliveryDialog">
      <DeliveryDialogHeader isEstimatedDate={isEstimatedDate} />
      <DeliveryCalendar
        setSelectedDate={handleChange(dateFieldName)}
        selectedDate={currentDate}
        // minDate={addWeekdays(moment(), 4).utc(true).toDate()}
      />
      <DeliveryTypeReminder
        deliveryType={deliveryType}
        orderNumber={orderNumber}
      />
      {!isEstimatedDate && (
        <TransporterSelector
          orders={formData.orders}
          currentTransporter={currentTransporter}
          setCurrentTransporter={setCurrentTransporter}
        />
      )}
      <OrdersSelector
        orders={orders || []}
        selectedOrders={formData.orders}
        onOrdersChange={handleChange("orders")}
        loading={
          ordersLoading || (formData?.orders?.length > 0 && !orders?.length > 0)
        }
      />
      <DeliveryDialogFooter
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        isSubmitDisabled={
          isSubmitDisabled ||
          !(isEstimatedDate
            ? moment(formData.estimatedDeliveryDate).isValid()
            : moment(formData.realDeliveryDate).isValid())
        }
      />
    </div>
  );
}

export default DeliveryDialog;
